/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { openPositionMembershipEntrySchema } from './openPositionMembershipEntrySchema';

export const openPositionMembershipsReplaceRequestSchema = z.object({
  get memberships() {
    return z.array(openPositionMembershipEntrySchema);
  },
});
